import { Component, Input } from '@angular/core';

@Component({
    selector: 'field-error-display-control',
    templateUrl: 'field-error-display.control.html',
    standalone: false,
})
export class FieldErrorDisplayControl {
    @Input()
    public errorMsg: string;
    @Input()
    public displayError: boolean;
}
